/* eslint-disable react/jsx-props-no-spreading */
import { Box } from '@mui/material';
import { useCallback, useContext, useEffect, useState } from 'react';
import UPButton from 'components/button';
import { useTranslation } from 'react-i18next';
import { IMinimumWage } from 'types/minimum-wage';
import { WAGE_INDEXATION__MINIMUM_WAGE_INDEXATION, WAGE_INDEXATION__NEXT_STEP } from 'translations/constants';
import IndexedWageValuesGrid from './IndexedWageValuesGrid';
import OriginalWageValuesGrid from './OriginalWageValuesGrid';
import { WageIndexationFlowButtonContainer, WageIndexationFlowCard, WageIndexationFlowStepContainer } from './styles';
import { WageIndexationFlowContext } from './WageIndexation';

const WageIndexationPanel: React.FC = () => {
  const { onClickNextStep, activeStep, setUpdatedMinimumWages } = useContext(WageIndexationFlowContext);
  const syncLeftScroll = useCallback((scrolledElement: Element, otherElement: Element) => {
    // eslint-disable-next-line no-param-reassign
    otherElement.scrollLeft = scrolledElement.scrollLeft;
  }, []);

  const [t] = useTranslation();

  const [updatedWages, setUpdatedWages] = useState<IMinimumWage[]>([]);

  const original = document.getElementsByClassName('MuiDataGrid-virtualScroller')[0];

  const indexed = document.getElementsByClassName('MuiDataGrid-virtualScroller')[1];

  useEffect(() => {
    if (original && indexed) {
      original.addEventListener('scroll', () => {
        syncLeftScroll(original, indexed);
      });

      indexed.addEventListener('scroll', () => {
        syncLeftScroll(indexed, original);
      });
    }
  }, [original, indexed, syncLeftScroll]);

  const goNextStep = () => {
    setUpdatedMinimumWages(updatedWages);
    onClickNextStep();
  };

  return (
    <WageIndexationFlowStepContainer activeStep={activeStep}>
      <WageIndexationFlowCard>
        <h5 style={{ marginTop: 0, marginBottom: 0 }}>{t(WAGE_INDEXATION__MINIMUM_WAGE_INDEXATION)}</h5>
        <Box id="minimum-wages-sync-tables">
          <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-evenly' }}>
            <OriginalWageValuesGrid />
            <IndexedWageValuesGrid setUpdatedWages={setUpdatedWages} />
          </Box>
          <WageIndexationFlowButtonContainer sx={{ marginTop: '2rem' }}>
            <UPButton text={t(WAGE_INDEXATION__NEXT_STEP)} onClick={goNextStep} />
          </WageIndexationFlowButtonContainer>
        </Box>
      </WageIndexationFlowCard>
    </WageIndexationFlowStepContainer>
  );
};

export default WageIndexationPanel;
